<template lang="pug">
  section#instacart-home.home(@mousemove="mousemove" ref="homeIns")
    img.home-cloud__left(src="@/assets/images/cloud-left.png" width="830" height="900")
    img.home-cloud__top(src="@/assets/images/cloud-top.png" width="407" height="235")
    .home-content
      img.home-content__carrot(src="@/assets/images/beyond-image-carrot.png" width="120" height="119")
      h1 Beyond the Cart: 
      //img.home-content__beyond(src="@/assets/images/beyond-the-Cart.svg")
      p.orange.text-center A Year of Essential Stories
      span.green.text-center.home-text__description As we reflect on the past year, one thing is clear — the Instacart shopper community has been a lifeline to millions of households across North America. We're highlighting the essential stories of more than 50 shoppers across each state and province who've offered their dedication and support over the past year. 
      img.home-content__powered.img-fluid.mx-auto.d-block(src="@/assets/images/powered-by-home.svg" alt="Instacart logo" width="256" height="55")
    img.home-cloud__right(src="@/assets/images/cloud-right.png" width="830" height="580")
</template>
<script>
import { gsap } from 'gsap'

export default {
  props:['home'],
  watch: { 
    home: function() { // watch it
      this.enterMotion();
    }
  },
  data(){
    return{
      home_load: this.home,
      cloudsMove: true,
      height: 0,
      width: 0
    } 
  },
  beforeMount() {
    //this.hideElements();
  },
	mounted() {
    this.hideElements();
    // if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    //     this.enterMotion()
    // } else {
    //     document.addEventListener('DOMContentLoaded', this.enterMotion())
    // }
		},
	methods: {
    calculateHeight() {
      this.height = this.$refs.homeIns.clientHeight;
      return this.height;
    },
    calculateWidth() {
      this.width = this.$refs.homeIns.clientWidth;
      return this.width;
    },
    hideElements:function(){
			const tl = gsap.timeline()
			
			//Header
      tl.to('.home-content__carrot', 0.1, {alpha:0},"0");
      tl.to('.home-content p', 0.1,{y:"+=100", opacity: 0},"0")
			tl.to('.home-cloud__left',0.1,{x:-100, alpha:0}, "0")
      tl.to('.home-cloud__right',0.1,{x:100, alpha:0}, "0")
      tl.to('.home-cloud__top',0.1,{alpha:0}, "0")
      tl.to('.instacart-nav', 0.1,{alpha:0, x:-50},"0")
      tl.to('.home-text__description', {alpha:0}, "0")
      tl.to('.home-content__powered', {alpha:0, y:-50}, "0")
      
		},
		enterMotion:function(){
			const tl = gsap.timeline()
			
			//Header
      tl.to('.home-content__carrot', 1, {alpha: 1}, "0");
      tl.to('.home-content__carrot', 15, {rotation:"360",  ease: "none", repeat:-1}, "0");
      tl.to('.home-content p', {y:0, opacity: 1,duration:0.5,ease: 'transitionVolet'},"0")
			tl.to('.home-cloud__left',{x:0, alpha:1, ease: "power3.out"}, "0.2")
      tl.to('.home-cloud__right',{x:0, alpha:1, delay: 0.5, ease: "power3.out"}, "0.2")
      tl.to('.home-cloud__top',{alpha:1, delay: 1}, "0.3")
      tl.to('.instacart-nav', {alpha:1, x:0, ease: "power3.out"}, "0.6")
      tl.to('.home-text__description', {alpha:1}, "0.6")
      tl.to('.home-content__powered', 1.5, {alpha:1, y:0}, "1")
      
		},
    mousemove(event) {
      if(this.cloudsMove)
        this.cloudsMoves(event.clientX, event.clientY);
    },
		cloudsMoves(x_pos, y_pos) {
    
			const tl = gsap.timeline()
    
      tl.to('.home-cloud__left', 1, {
        x: (x_pos - this.calculateWidth() / 2) / this.calculateWidth() * -20,
        y: (y_pos - this.calculateHeight() / 2) / this.calculateHeight() * -20
      }, "0");
      
      tl.to('.home-cloud__right', 1, {
        x: (x_pos - this.calculateWidth() / 2) / this.calculateWidth() * -40,
        y: (y_pos - this.calculateHeight() / 2) / this.calculateHeight() * -40
      }, "0");
      
      tl.to('.home-cloud__top', 1, {
        x: (x_pos - this.calculateWidth() / 2) / this.calculateWidth() * -70,
        y: (y_pos - this.calculateHeight() / 2) / this.calculateHeight() * -70
      }, "0");
      
      tl.to('.home-content', 1, {
        x: (x_pos - this.calculateWidth() / 2) / this.calculateWidth() * -25,
        y: (y_pos - this.calculateHeight() / 2) / this.calculateHeight() * -25
      }, "0");
    
		},
    scrollMap(){
      alert('Scroll');
    }
	},
}
</script>
<style lang="scss">
  #instacart-home{
    width: 100vw;
    height: 100vh;
    background-color: $soft_brown;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
  }
  
  
</style>
